export const APPOINTMENT_LEAD_PERIODS = [7, 30, 90];

export function normalizeAppointmentLeadDays(days) {
  return APPOINTMENT_LEAD_PERIODS.includes(days) ? days : 30;
}

export function appointmentLeadPeriodStart(days, now = Date.now()) {
  const normalizedDays = normalizeAppointmentLeadDays(days);
  return new Date(new Date(now).getTime() - normalizedDays * 24 * 60 * 60 * 1000).toISOString();
}

export async function countAppointmentLeads(client, days, now = Date.now()) {
  const { count, error } = await client
    .from('click_externos')
    .select('*', { head: true, count: 'exact' })
    .in('tipo', ['whatsapp', 'telefone'])
    .gte('created_at', appointmentLeadPeriodStart(days, now));

  if (error) throw error;
  return count ?? 0;
}
